export const PEDIATRIC_DENTAL_RATE_REDUCTION = 30.46;

export const NA = "N/A";

export enum QualifyingLifeEventType {
  EmployerLoss,
  MaritalStatusChange,
  OutOfStateMove,
  NewChild,
  Pregnancy,
  Other,
  IncomeChange,
  None
}

export const QUALIFYING_LIFE_EVENTS: any = {
  "New York": [
    { eventType: QualifyingLifeEventType.EmployerLoss, label: "I lost my employer health plan" },
    { eventType: QualifyingLifeEventType.MaritalStatusChange, label: "My marital status changed (married or divorced)" },
    { eventType: QualifyingLifeEventType.OutOfStateMove, label: "I moved to New York from another state" },
    { eventType: QualifyingLifeEventType.NewChild, label: "I welcomed a new child into my family" },
    { eventType: QualifyingLifeEventType.Pregnancy, label: "Pregnancy" },
    { eventType: QualifyingLifeEventType.Other, label: "Other" },
    { eventType: QualifyingLifeEventType.None, label: "None of these apply" }
  ],
  Vermont: [
    { eventType: QualifyingLifeEventType.EmployerLoss, label: "Loss of affordable minimum essential coverage or government-sponsored coverage" },
    { eventType: QualifyingLifeEventType.NewChild, label: "Gain a dependent through marriage or birth or adoption" }, // keep comma out of label for csv export
    { eventType: QualifyingLifeEventType.OutOfStateMove, label: "Move to Vermont or change in citizenship/immigration status" },  // keep comma out of label for csv export
    { eventType: QualifyingLifeEventType.MaritalStatusChange, label: "Change in marital status" },
    { eventType: QualifyingLifeEventType.Pregnancy, label: "Pregnancy" },
    { eventType: QualifyingLifeEventType.IncomeChange, label: "Change in income" },
    { eventType: QualifyingLifeEventType.Other, label: "Other" },
    { eventType: QualifyingLifeEventType.None, label: "None of these apply" }
  ],
};

export const FACETS_CHARACTER_LIMITS = {
  firstName: 15,
  middleName: 1,
  lastName: 40,
  suffix: 3,
  address1: 40,
  address2: 40,
  city: 19,
  county: 20
};

export const phoneNumbers = {
  support: "1-800-825-5687",
  medicare: "1-800-324-3899",
  talkMVP: '1-800-TALK-MVP',
}

export const PO_Box = "MVP Health Care, Inc., PO BOX 22863, New York, NY 10087-6864"
